import { selectTalentProfile } from 'redux/User/selector'
import { useTypedSelector } from '../../redux/rootReducer'
import { useImage } from 'hooks/useImage'

export function useHeaderImage() {
  const talentProfile = useTypedSelector(selectTalentProfile)
  const { avatar: headerImageSrc } = talentProfile || {}

  return useImage(headerImageSrc || '')
}
